<!--
  提现详情
  lovi 2020-1-13
-->
<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar
      :title="
        data.type == 9
          ? $t('withdraw.reservationWithdraw')
          : $t('withdraw.outletsWithdraw')
      "
      :fixed="true"
      left-arrow
      @click-left="navBarBack"
    >
    </van-nav-bar>

    <div class="scroll-wrapper">
      <scroll>
        <template v-if="data.type == 9">
          <van-cell
            :title="$t('withdraw.amountLimit')"
            :value="data.limit_money"
          />
          <van-cell
            :title="$t('withdraw.serviceHours')"
            :value="data.limit_time"
          />
          <van-cell
            :title="$t('withdraw.serviceDesc')"
            :value="data.service_description"
          />
          <van-cell :title="$t('withdraw.serviceHotline')">
            <span slot="default" @click="_telephone(data.service_hotline)">
              {{ data.service_hotline }}
            </span>
          </van-cell>
          <van-cell
            :title="$t('withdraw.serviceArea')"
            :value="data.service_range"
          />
          <div class="button-wrap">
            <van-button
              block
              type="primary"
              @click="_telephone(data.service_hotline)"
            >
              {{ $t("withdraw.dialNumber") }}
            </van-button>
          </div>
        </template>
        <template v-else>
          <div class="title text-blue">
            {{ $t("withdraw.officialContactInfo") }}
          </div>
          <van-cell
            :title="$t('withdraw.onlineServiceCustomer')"
            :value="$t('withdraw.eepayOnlineServiceCustomer')"
            to="/service"
          />
          <van-cell :title="$t('withdraw.mobileNumber')">
            <span slot="default" @click="_telephone(data.service_phone)">
              {{ data.service_phone }}
            </span>
          </van-cell>
          <van-cell :value="data.wx_number">
            <div slot="title">
              <span>
                {{ $t("common.weChat") }}
              </span>
              <i
                class="icon-copy"
                :data-clipboard-text="data.wx_number"
                @click="copyText"
              ></i>
            </div>
          </van-cell>
          <van-cell :value="data.fb_number">
            <div slot="title">
              <span>Facebook</span>
              <i
                class="icon-copy"
                :data-clipboard-text="data.fb_number"
                @click="copyText"
              ></i>
            </div>
          </van-cell>

          <div class="title text-blue">{{ $t("withdraw.doorToDoor") }}</div>
          <van-cell :title="$t('withdraw.mobileNumber')">
            <span slot="default" @click="_telephone(data.service_hotline)">
              {{ data.service_hotline }}
            </span>
          </van-cell>

          <div v-for="(item, index) in data.service_net" :key="index">
            <div class="title text-blue">{{ item.name }}</div>
            <van-cell :value="item.address">
              <div slot="title">
                <span> {{ $t("common.address") }} </span>
                <i
                  class="icon-copy"
                  :data-clipboard-text="item.address"
                  @click="copyText"
                ></i>
              </div>
            </van-cell>
            <van-cell :title="$t('withdraw.consultingNumber')">
              <span slot="default" @click="_telephone(item.phone)">
                {{ item.phone }}
              </span>
            </van-cell>
          </div>
        </template>
      </scroll>
    </div>
  </div>
</template>

<script>
import Clipboard from "clipboard";
export default {
  props: {
    data: {
      type: Object, //父页面
      default: function() {
        return {};
      }
    }
  },
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    navBarBack() {
      // 返回事件
      this.$emit("update:detailFlag", false);
    },
    copyText() {
      var clipboard = new Clipboard(".icon-copy");
      clipboard.on("success", e => {
        console.info("Action:", e.action);
        this.$toast(this.$t("common.copySuccess"));
        clipboard.destroy(); // 释放内存
      });
      clipboard.on("error", e => {
        console.info("error:", e.action);
        this.$toast(this.$t("common.browserNoCopy"));
        clipboard.destroy(); // 释放内存
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.scroll-wrapper {
  background: #f4f4f4;
  .title {
    font-size: 14px;
    padding: 10px 15px;
    line-height: 1;
  }
  /deep/.van-cell__title {
    flex: initial;
    margin-right: 10px;
    div {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .icon-copy {
        margin-left: 10px;
        width: 10px;
        height: 12px;
        background: url("~@/assets/images/public/icon_copy@2x.png") no-repeat;
        background-size: 100%;
      }
    }
  }
}
</style>
